import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import {
  Router,
  NavigationStart,
  NavigationCancel,
  NavigationEnd,
} from '@angular/router';
import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
} from '@angular/common';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from './api.service';
import { EmitterService } from './EmitterService';

declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    Location,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  location: any;
  routerSubscription: any;
  scrollPercent: number = 0;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const maxScroll = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    ) - document.documentElement.clientHeight;

    if (maxScroll > 0) {
      this.scrollPercent = Math.round((scrollPosition / maxScroll) * 100);
    } else {
      this.scrollPercent = 0;
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  constructor(
    private router: Router,
    private _translateService: TranslateService,
    private apiService: ApiService,
    private emitterService: EmitterService
  ) {
    // Add languages
    this._translateService.addLangs(['en', 'bn', 'ar']);

    // Set the default language
    this._translateService.setDefaultLang('en');

    // Use a language
    this._translateService.use('en');
  }

  ngOnInit() {
    let body = {
      username: 'appapi@fbic',
      password: 'FbicAPI@23',
    };

    let clientData = localStorage.getItem('clientData');

    if (this.apiService.isTokenExpired(clientData)) {
      this.apiService.getToken(body).subscribe((response: any) => {
        console.log(response, 'response getToken');

        localStorage.setItem('clientData', JSON.stringify(response.data));

        this.FetchNoticeData(JSON.stringify(response.data));
      });
    } else {
      this.FetchNoticeData(clientData);
    }
    this.recallJsFuntions();
  }

  FetchNoticeData(clientData) {
    this.apiService.getNotices(clientData).subscribe((response: any) => {
      console.log(response, 'response Notices');

      let sortedNotice = this.sortByStartDate(response.data);

      localStorage.setItem('noticeData', JSON.stringify(sortedNotice));

      this.emitterService.changeMessage(true);
    });
  }
  private getTime(date?: Date) {
    return date != null ? new Date(date).getTime() : 0;
  }

  public sortByStartDate(array: any): any {
    return array.sort((a: any, b: any) => {
      return this.getTime(b.CreatedDate) - this.getTime(a.CreatedDate);
    });
  }
  recallJsFuntions() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        $('.preloader').fadeIn('slow');
      }
    });
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationEnd || event instanceof NavigationCancel
        )
      )
      .subscribe((event) => {
        $.getScript('../assets/js/custom.js');
        this.location = this.router.url;
        if (!(event instanceof NavigationEnd)) {
          return;
        }
        window.scrollTo(0, 0);
      });
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }
}
